module.exports = __webpack_public_path__ + "static/media/Avellino.ab59c49e.png";